/**
 * Simple Timeout function
 * @param {*} ms Time to wait in ms
 * @returns Promise when timeout ended
 */
function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export { timeout }
